var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCrossRed = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 10,
  viewBox: "0 0 10 10",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.03046 9.04061L5 6.01015L1.96954 9.04061L0.95939 8.03046L3.98985 5L0.95939 1.96954L1.96954 0.95939L5 3.98985L8.03046 0.95939L9.04061 1.96954L6.01015 5L9.04061 8.03046L8.03046 9.04061Z"
})));
export { SvgCrossRed as ReactComponent };
export default __webpack_public_path__ + "76fe83037eae481f4db0fb821f2744b2.svg";